import React from 'react';
import Prism from 'prismjs';

export default function CodeHighlight({ code, language, style = {} }) {
  return (
    <pre className={`language-${language}`} style={{ ...style }}>
      <code
        className={`language-${language}`}
        dangerouslySetInnerHTML={{
          __html: Prism.highlight(code, Prism.languages[language], language),
        }}
        style={{
          fontSize: '0.875em',
        }}
      ></code>
    </pre>
  );
}
